const INITIAL_STATE = {
  agents: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_DEVELOP_AGENT_GRID': {
      return { ...state, agents: [...action.payload] };
    }
    default:
      return state;
  }
};
